import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { permissions } from '../../shared/permissions';
import { UserService } from '../user.service';
import { result } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../shared/interfaces';
import { DialogService } from '../../dialog/dialog.service';
import { configuredFilters } from './filter-configurations';
import { Filter } from '../../search.filter/search-filter.component';
import { RoleService } from '../../role/role.service';

@Component({
  selector: 'app-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.scss'],
})
export class AdminListComponent implements OnInit {
  rows: any[];
  canEdit = false;
  count: number;
  loadDebounced = new Subject();
  url = 'user/admins';
  loading = true;
  definedFilters: Filter[] = configuredFilters;

  actions = {
    list: [
      {
        label: 'Archive',
        callback: (user: User) => async () => {
          return this.archive(user);
        },
        show: item => () => {
          return this.show(item);
        },
      },
    ],
    archived: [
      {
        label: 'Restore',
        callback: (user: User) => async () => {
          return this.restore(user);
        },
        show: item => () => {
          return this.show(item);
        },
      },
    ],
  };

  column = [
    { field: 'name', header: 'Name', type: 'text', orderBy: 'user.firstName' },
    { field: 'email', header: 'Email', type: 'text', orderBy: 'user.email' },
    { field: 'roles', header: 'Roles', type: 'text' },
  ];
  tabsName = { active: 'Active', archived: 'Inactive Admins' };

  constructor(
    public userService: UserService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    public dialog: DialogService,
    public roleService: RoleService,
  ) {
    console.log('adminlist');
  }

  async ngOnInit() {
    this.canEdit = await this.userService.hasPermissions([permissions.USER.WRITE]);
    const roleFilter = this.definedFilters.find(filter => filter.name === 'role');

    if (roleFilter) {
      roleFilter.options = (await this.roleService.list()).map(({ name }: { name: string }) => ({
        label: name,
        id: name,
      }));
    }
  }

  loadData() {
    this.loadDebounced.next();
  }

  async loadDataLive($event: any): Promise<void> {
    try {
      this.loading = true;
      const [rows, count] = await this.userService.listAdmins($event);

      this.rows = rows.map(r => ({
        ...r,
        roles: r.roles.map(role => role.name).join(', '),
      }));

      this.count = count;
    } catch (error) {
      console.error('Error loading data:', error);
      this.toastr.error('Error loading data!');
    } finally {
      this.loading = false;
    }
  }

  rolesToString(roles: any[]) {
    return (roles || []).map(r => r.name).join(', ');
  }

  async archive(user: User): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.dialog.confirm().show({
        message: `Do you really want to archive '${user.name}'?`,
        confirmed: async () => {
          try {
            await this.userService.archive(user.id);
            resolve();
          } catch (error) {
            console.error('Error archiving the admin:', error);
            reject(error);
          }
        },
        canceled: () => {
          resolve();
        },
      });
    });
  }

  async restore(user: User): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.dialog.confirm().show({
        message: `Do you really want to restore '${user.name}'?`,
        confirmed: async () => {
          try {
            await this.userService.restore(user.id);
            resolve();
          } catch (error) {
            console.error('Error restoring the admin:', error);
            reject(error);
          }
        },
        canceled: () => {
          resolve();
        },
      });
    });
  }

  show(item) {
    return this.canEdit && item;
  }

  // async remove(ev: Event, role: Role) {
  //   ev.preventDefault();

  //   this.confirm.show({
  //     message: `Do you really want to permanently delete '${role.name}'?`,
  //     confirmed: async () => {
  //       await this.userService.remove(role.id);
  //       this.loadDataLive();
  //     },
  //   });
  // }
}
